import { Component, Input, Output, EventEmitter, SimpleChanges, AfterViewChecked, ViewChild, ElementRef } from '@angular/core';
import { WatchVideoComponent } from '../../../watch-video/watch-video.component';
import { DEFAULT_PANEL_CONFIG, PanelConfig } from './panel.modal';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { ICONS } from '../../../_helpers/icons.constants';
@Component({
  selector: 'panel',
  templateUrl: './panel.component.html',
  standalone: true,
  imports: [WatchVideoComponent, CommonModule,SharedModule]
})
export class PanelComponent implements AfterViewChecked {

  /** Close event */
  @Output() close = new EventEmitter<void>();
  @Input() panelInput: PanelConfig = { ...DEFAULT_PANEL_CONFIG };
  ICONS = ICONS;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.panelInput) {
      const val: PanelConfig = changes.panelInput.currentValue || {};
      this.panelInput = { ...DEFAULT_PANEL_CONFIG, ...val };
    }
  }
  isClosing = false;
  isScrolledToBottom = false;
  private scrollCheckedOnce = false;

  @ViewChild('panelBody') panelBodyRef?: ElementRef<HTMLElement>;

  ngAfterViewChecked(): void {
    if (!this.scrollCheckedOnce && this.panelBodyRef) {
      this.scrollCheckedOnce = true;
      this.updateScrolledToBottom(this.panelBodyRef.nativeElement);
    }
  }

  onBodyScroll(body: HTMLElement): void {
    this.updateScrolledToBottom(body);
  }

  /** Smoothly scroll the panel body to the bottom (used by the "Scroll to accept" hint). */
  scrollToBottom(body: HTMLElement): void {
    body.scrollTo({ top: body.scrollHeight, behavior: 'smooth' });
  }

  private updateScrolledToBottom(body: HTMLElement): void {
    const threshold = 4;
    this.isScrolledToBottom = body.scrollHeight - body.clientHeight - body.scrollTop <= threshold;
  }

  onClose(): void {
    if (this.isClosing) return;
      this.close.emit();
  }
}